<template>
  <router-view />
</template>

<script>
export default {
  name: 'SafariFlyingDoctors'
}
</script>
